// removed by extract-text-webpack-plugin
module.exports = {"content":"XdAzUhCXodISb31OWEiGk","main":"_1Cs9HL-NKLRh54nKs-uh-x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Template/PageContent.scss
// module id = 2164
// module chunks = 1